import { Button, createStyles, Theme, WithStyles, withStyles } from '@material-ui/core'
import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

const styles = (theme: Theme) =>
  createStyles({
    button: { margin: theme.spacing() },
    deleteBtn: {
      background: theme.palette.error.main,
      '&:hover': {
        backgroundColor: theme.palette.error.dark,
      },
    },
    delRuleBtn: {
      border: `solid 1px ${theme.palette.error.main}`,
      color: theme.palette.error.main,
      '&:hover': {
        border: `solid 1px ${theme.palette.error.dark}`,
        backgroundColor: theme.customPalette.outlinedErrorHover,
      },
    },
    publishBtn: {
      background: theme.customPalette.success.main,
      '&:hover': {
        backgroundColor: theme.customPalette.success.dark,
      },
    },
  })

interface IButtonProps extends WithStyles {
  className?: string
  disabled?: boolean
  id?: string
  label?: string
  onClick: () => void
}

export const CancelButton = withStyles(styles)(({ id, label, onClick, disabled, className, classes }: IButtonProps) => {
  const { t } = useTranslation()
  return (
    <Button id={id} variant="contained" className={className || classes.button} onClick={onClick} disabled={disabled}>
      {label || t('button.cancel')}
    </Button>
  )
})

export const SaveButton = withStyles(styles)(({ id, label, onClick, disabled, className, classes }: IButtonProps) => {
  const { t } = useTranslation()
  return (
    <Button
      id={id}
      variant="contained"
      color="primary"
      className={className ?? classes.button}
      onClick={onClick}
      disabled={disabled}
    >
      {label || t('button.save')}
    </Button>
  )
})

export const DeleteButton = withStyles(styles)(({ id, label, onClick, disabled, className, classes }: IButtonProps) => {
  const { t } = useTranslation()
  return (
    <Button
      id={id}
      variant="contained"
      color="primary"
      className={className || classNames(classes.button, classes.deleteBtn)}
      onClick={onClick}
      disabled={disabled}
    >
      {label || t('button.delete')}
    </Button>
  )
})

export const AddRuleButton = withStyles(styles)(
  ({ id, label, onClick, disabled, className, classes }: IButtonProps) => {
    const { t } = useTranslation()
    return (
      <Button
        id={id}
        variant="outlined"
        color="primary"
        className={className || classNames(classes.button)}
        onClick={onClick}
        disabled={disabled}
      >
        {label || t('button.add_rule')}
      </Button>
    )
  }
)

export const DeleteRuleButton = withStyles(styles)(
  ({ id, label, onClick, disabled, className, classes }: IButtonProps) => {
    const { t } = useTranslation()
    return (
      <Button
        id={id}
        variant="outlined"
        color="secondary"
        className={className || classNames(classes.button, classes.delRuleBtn)}
        onClick={onClick}
        disabled={disabled}
      >
        {label || t('button.delete')}
      </Button>
    )
  }
)

export const PublishButton = withStyles(styles)(
  ({ id, label, onClick, disabled, className, classes }: IButtonProps) => {
    const { t } = useTranslation()
    return (
      <Button
        id={id}
        variant="contained"
        color="primary"
        className={className || classNames(classes.button, classes.publishBtn)}
        onClick={onClick}
        disabled={disabled}
      >
        {label || t('button.publish')}
      </Button>
    )
  }
)

export const AddTimeSlotButton = withStyles(styles)(
  ({ id, label, onClick, disabled, className, classes }: IButtonProps) => {
    const { t } = useTranslation()
    return (
      <Button
        id={id}
        variant="outlined"
        color="primary"
        className={className ?? classNames(classes.button, classes.addTimeSlotBtn)}
        onClick={onClick}
        disabled={disabled}
      >
        {label ?? t('button.add_time_slot')}
      </Button>
    )
  }
)

export const DuplicateButton = withStyles(styles)(({ label, onClick, disabled, className, classes }: IButtonProps) => {
  const { t } = useTranslation()
  return (
    <Button
      variant="outlined"
      color="primary"
      className={className ?? classes.button}
      onClick={onClick}
      disabled={disabled}
    >
      {label ?? t('button.duplicate')}
    </Button>
  )
})
